/**************************************************
 * hooks/dash/useDashboardData.js
 *
 * @author  LSJ
 * @since   1.0 (2025-02-28)
 * @version 1.0
 **************************************************/
import { useQuery } from "@tanstack/react-query";
import { fetchData } from "@utils/dashboardApi";

/**
 * useDashboardData
 *
 * 주어진 엔드포인트와 queryKeySuffix, compCode를 기반으로 데이터를 불러오는 범용 커스텀 훅.
 * 필요 시 dataTransform 함수를 인자로 받아 데이터를 변환할 수 있습니다.
 *
 * @param   {string}    endpoint        API 엔드포인트 (예: "/user/dash/current")
 * @param   {string}    queryKeySuffix  쿼리 키의 접미사 (예: "currentData")
 * @param   {object}    params          API 호출에 사용할 파라미터 객체 (예: { compCode, otherParam })
 * @param   {Function}  [dataTransform] (선택 사항) 데이터를 후처리할 함수
 * @returns {object}                    { data, isLoading, isError, error, refetch }
 */
const useDashboardData = (endpoint, queryKeySuffix, params, restType, data, dataTransform) => {
  // params 객체를 쿼리 키에 포함시켜 파라미터가 달라지면 쿼리가 재실행되도록 함.
  const queryKey = [queryKeySuffix, params];

  return useQuery({
    queryKey,
    queryFn: () => fetchData(endpoint, params, restType, data),
    enabled: !!(params && params.compCode && params.compCode.trim() !== ""), 
    staleTime: 30000, 
    refetchOnMount: true, 
    refetchOnWindowFocus: true, 
    select: dataTransform, 
  });
};

export default useDashboardData;
